import { Icon, IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { EntityInfoAccordionProps as Props } from './types';

export const EntityInfoAccordion = memo(
  ({
    className,
    children,
    icon,
    title,
    summaryActions,
    defaultExpanded,
  }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('EntityInfoAccordion', className)}
        sx={SX.root}
        variant="outlined"
        color="default"
        defaultExpanded={defaultExpanded}
      >
        <AccordionSummary
          expandIcon={
            <IconButton
              icon="arrow-accordion"
              iconSize={12}
              size="xsmall"
              variant="text"
            />
          }
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Box sx={SX.headerWrapper}>
              <Icon name={icon ?? 'info'} size={20} color="primary.500" />
              <Typography variant="body3" fontWeight={700} color="grey.700">
                {title}
              </Typography>
            </Box>
            {summaryActions && (
              <Box sx={SX.summaryActions}>{summaryActions}</Box>
            )}
          </Stack>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Styled.Wrapper>
    );
  }
);

EntityInfoAccordion.displayName = 'EntityInfoAccordion';
